import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getSystemAgentsList, getSystemAgentRoles } from '@/service/systemControl'

const emptyList = {
  records: [],
  totalRow: 0
}

/** 打开「分配角色」时拉取该成员当前绑定角色；query 需含 agentId */
export const fetchSystemAgentRoles = createAsyncThunk(
  'systemAgent/fetchAgentRoles',
  async ({ query = {} } = {}, { rejectWithValue }) => {
    try {
      const agentId = query.agentId
      if (agentId == null || agentId === '') {
        return rejectWithValue('缺少成员 id')
      }
      const response = await getSystemAgentRoles(agentId)
      return {
        data: response.data,
        query
      }
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.msg || error?.message || '加载已绑定角色失败'
      )
    }
  }
)

export const fetchSystemAgentsList = createAsyncThunk(
  'systemAgent/fetchList',
  async ({ query = {} } = {}, { rejectWithValue }) => {
    try {
      const response = await getSystemAgentsList(query)
      return {
        data: response.data,
        query
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data?.msg || error?.message || '加载管理员列表失败')
    }
  }
)

const systemAgentSlice = createSlice({
  name: 'systemAgent',
  initialState: {
    fetching: false,
    error: null,
    query: {},
    data: { ...emptyList },
    /** 单成员已绑定角色（与列表接口分离，避免依赖行数据是否含 roles） */
    agentRoles: {
      fetching: false,
      error: null,
      query: {},
      data: null
    }
  },
  reducers: {
    resetAgentRolesState: (state) => {
      state.agentRoles = {
        fetching: false,
        error: null,
        query: {},
        data: null
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSystemAgentsList.pending, (state) => {
        state.fetching = true
        state.error = null
      })
      .addCase(fetchSystemAgentsList.fulfilled, (state, action) => {
        state.fetching = false
        state.error = null
        state.query = action.payload.query
        state.data = action.payload.data || { ...emptyList }
      })
      .addCase(fetchSystemAgentsList.rejected, (state, action) => {
        state.fetching = false
        state.error = action.payload ?? action.error?.message ?? null
      })
      .addCase(fetchSystemAgentRoles.pending, (state, action) => {
        state.agentRoles.fetching = true
        state.agentRoles.error = null
        state.agentRoles.query = action.meta.arg?.query ?? {}
        state.agentRoles.data = null
      })
      .addCase(fetchSystemAgentRoles.fulfilled, (state, action) => {
        state.agentRoles.fetching = false
        state.agentRoles.error = null
        state.agentRoles.query = action.payload.query
        state.agentRoles.data = action.payload.data
      })
      .addCase(fetchSystemAgentRoles.rejected, (state, action) => {
        state.agentRoles.fetching = false
        state.agentRoles.error = action.payload ?? action.error?.message ?? null
        state.agentRoles.data = null
      })
  }
})

export const { resetAgentRolesState } = systemAgentSlice.actions
export default systemAgentSlice.reducer
